import { literal, object, type InferOutput } from 'valibot'
import { Engine } from '../../../../engine/Engine.type'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const StartRoundActionSchema = object({
  type: literal(ActionType.Game.StartRound),
})

export type StartRoundAction = InferOutput<typeof StartRoundActionSchema>

export function createStartRoundAction(): StartRoundAction {
  return {
    type: ActionType.Game.StartRound,
  }
}

export async function handleStartRoundAction(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  engine: Engine,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: StartRoundAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  // placeholder for future events hooks
}
